<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import axios from 'axios';
import snackbarMixin from '@/mixins/snackbar';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import TaskListItem from './components/TaskListItem';
import NewTaskDialog from './components/NewTaskDialog';
import EditTaskDialog from './components/EditTaskDialog';
import NoteDialog from './components/NoteDialog';

export default {
  name: 'TaskList',
  components: {
    TaskListItem,
    NewTaskDialog,
    EditTaskDialog,
    NoteDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin, snackbarMixin],
  props: {
    parentResource: {
      type: String,
      required: false,
      default: '',
    },
    parentResourceId: {
      type: Number,
      required: false,
      default: null,
    },
    path: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Bezeichnung', value: 'name' }, { text: 'Benutzer', value: 'user' }, { text: 'Priorität', value: 'priority' },
        { text: 'Status', value: 'status' }, { text: 'Deadline', value: 'deadline' }, { text: 'Aktionen', value: '' }],
      showNewTaskDialog: false,
      showEditTaskDialog: false,
      isNoteDialogDisplayed: false,
      task: {},
      notes: [],
    };
  },
  computed: {
    ...mapState(['taskList']),
    ...mapState('taskList', ['meta']),
    ...mapGetters('app', ['auth']),
  },
  mounted() {
    this.paginationParams.parentResource = this.parentResource;
    this.paginationParams.parentResourceId = this.parentResourceId;
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('taskList', { fetchData: 'fetchTaskList' }),
    ...mapActions('taskList', { deleteTask: 'deleteTask' }),
    showTaskDialog(taskId) {
      axios.get(`/task/${taskId}`)
        .then((response) => {
          this.task = response.data;
          this.showEditTaskDialog = true;
        })
        .catch((err) => {
          console.log(err);
          this.showEditTaskDialog = false;
        });
    },
    _delete(taskId) {
      return this.deleteTask({ id: taskId })
        .then(() => {
          this.fetchData({
            parentResource: this.parentResource, parentResourceId: this.parentResourceId,
          });
        })
        .catch(() => {
          this.showErrorMessage('Das Löschen ist fehlgeschlagen.');
        });
    },
    showNoteDialog(taskId) {
      axios.get(`/task/${taskId}`)

        .then((response) => {
          this.task = response.data;
          this.isNoteDialogDisplayed = true;
        })
        .catch(() => {
          this.isNoteDialogDisplayed = false;
        });
    },
  },
};
</script>

<template>
  <div class="task-list">
    <template v-if="taskList.hasError">
      <p class="js-error-template ma-3">Failed to fetch task list. Please try again!</p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottask>
          <v-btn icon slot="activator" @click="showNewTaskDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Neu</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            icon
            @click="fetchData({parentResource: parentResource, parentResourceId: parentResourceId})"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        v-if="taskList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="taskList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="taskList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.user ? props.item.user.username : null }}</td>
            <td>{{ props.item.priority }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.deadline }}</td>
            <td>
              <v-btn
                slot="activator"
                icon
                @click="showTaskDialog(props.item.id)">
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn
                slot="activator"
                icon
                @click="showNoteDialog(props.item.id)">
                <v-icon>note</v-icon>
              </v-btn>

              <v-btn
                v-if="auth.hasDeleteRights"
                slot="activator"
                icon
                @click="_delete(props.item.id)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

    <NewTaskDialog
      v-if="showNewTaskDialog"
      :parent-resource="parentResource"
      :parent-resource-id="parentResourceId"
      @cancel="showNewTaskDialog = false"
    />

    <EditTaskDialog
      v-if="showEditTaskDialog"
      :parent-resource="parentResource"
      :parent-resource-id="parentResourceId"
      :task="task"
      @cancel="showEditTaskDialog = false"
    />

    <NoteDialog
      v-if="isNoteDialogDisplayed"
      :task="task"
      @cancel="isNoteDialogDisplayed = false"
    />

  </div>
</template>


<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
